module.exports = __webpack_public_path__ + "static/img/8.8112f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8.png
// module id = 204
// module chunks = 1